(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

    ngModule.service('$Orders', function($firebaseArray, $firebaseObject, $q) {
        var fireRef = firebase.database().ref().child('orders');
        var list = $firebaseArray(fireRef);
        // Note to self - the data model has changed and not all of these methods
        // have been updated the model is now:
        // orders -> storeId -> orderId
        // if sometihng doesnt' work below, check it twice

        return {
            ref: fireRef,
            add: function (obj) {
                return fireRef.push(obj);
            },
            addOrderToStore: function (storeId, order) {
                return $q(function(resolve, reject) {
                    resolve($firebaseObject(fireRef.child(storeId).push(order)));
                });
            },
            get: function(id) {
                return $firebaseObject(fireRef.child(id));
            },
            getOrderByStore: function(storeId, orderId) {
                return $q(function(resolve, reject) {
                    resolve($firebaseObject(fireRef.child(storeId).child(orderId)));
                });
            },

            findByStore: function(store) {
                var data = [];

                if (store) {
                    var query = fireRef.orderByChild('store').equalTo(store.$id);
                    query.on("child_added", function(snapshot) {
                      data.push(snapshot.val());
                    });
                } else {
                    return $firebaseArray(fireRef);
                }

                return data;
            },
            all: function(store) {
                var deferred = $q.defer();
                var data = [];

                if (store) {


                    fireRef.child(store.$id).once('value').then(function(snapshot) {

                        deferred.resolve(snapshot.val());
                      //var username = snapshot.val().username;
                      // ...
                    });



                    // var query = fireRef.child(store.$id);//.orderByChild('store').equalTo(store.$id);
                    //
                    // query.on('once', function(snapshot) {
                    //
                    //     console.log('snap', snapshot);
                    //
                    //
                    // })
                    // // query.on("child_added", function(snapshot) {
                    // //   data.push(snapshot.val());
                    // // });
                    //
                    // deferred.resolve(data);
                } else {

                    list.$loaded().then(function(data) {
                        deferred.resolve(data);
                    });
                }

                return deferred.promise;
            },
            getTeamOrderedProducts: function(storeId) {
                var deferred = $q.defer();
                var data = [];

                if (storeId) {

                    fireRef.child(storeId).once('value').then(function(snapshot) {

                        // console.log('snapshot', snapshot.val());
                        //
                        let productRowInTable = {
                            orderedBy: '',
                            orderedFor: '',
                            productName: '',
                            inPackage: false,
                            sizes: '',
                            // sizesCost: 0,
                            color: '',
                            // colorCost: '',
                            inseam: '',
                            // inseamCost: 0,
                            fit: '',
                            // fitCost: 0,
                            customName: '',
                            // customNameFee: 0,
                            customNumber: '',
                            // customerNumberFee: 0,
                            quantity: 0,
                            orderID: '',
                            created: null,
                        };

                        let products = [];

                        _.forEach(snapshot.val(), (order, key) => {

                            _.forEach(order.products, (product) => {

                                let tableProduct = angular.copy(productRowInTable);

                                tableProduct.productName = product.name;

                                _.forEach(product.properties, (property, propKey) => {

                                    tableProduct[propKey] = property.name;

                                });
                                tableProduct.quantity = product.quantity;
                                tableProduct.created = order.timestamp;
                                tableProduct.orderID = key;
                                tableProduct.orderedBy = order.checkoutDetails.orderedBy;
                                tableProduct.orderedFor = order.checkoutDetails.orderedFor || '';

                                products.push(tableProduct);

                            });

                            _.forEach(order.packages, (thePackage) => {

                                _.forEach(thePackage.customerPackageProducts, (product) => {

                                    let tableProduct = angular.copy(productRowInTable);

                                    tableProduct.productName = product.name;
                                    tableProduct.inPackage = true;

                                    _.forEach(product.properties, (property, propKey) => {

                                        tableProduct[propKey] = property.name;

                                    });

                                    tableProduct.quantity = product.quantity;
                                    tableProduct.created = order.timestamp;
                                    tableProduct.orderID = key;
                                    tableProduct.orderedBy = order.checkoutDetails.orderedBy;
                                    tableProduct.orderedFor = order.checkoutDetails.orderedFor || '';


                                    products.push(tableProduct);

                                });

                            });

                        });

                        deferred.resolve(products);

                    });

                } else {

                    deferred.resolve(false);

                }

                return deferred.promise;
            },
            getStoreOrderedProducts: function(store) {
                var deferred = $q.defer();
                var data = [];

                if (store) {

                    fireRef.child(store.$id).once('value').then(function(snapshot) {

                        let productRowInTable = {
                            orderedBy: '',
                            orderedFor: '',
                            productName: '',
                            inPackage: false,
                            sizes: '',
                            // sizesCost: 0,
                            color: '',
                            // colorCost: '',
                            inseam: '',
                            // inseamCost: 0,
                            fit: '',
                            // fitCost: 0,
                            customName: '',
                            // customNameFee: 0,
                            customNumber: '',
                            // customerNumberFee: 0,
                            basePrice: 0,
                            pricePerUnit: 0,
                            quantity: 0,
                            orderID: '',
                            created: null,
                        };

                        let products = [];

                        _.forEach(snapshot.val(), (order, key) => {

                            _.forEach(order.products, (product) => {

                                let tableProduct = angular.copy(productRowInTable);

                                tableProduct.productName = product.name;

                                _.forEach(product.properties, (property, propKey) => {

                                    tableProduct[propKey] = property.name;

                                });

                                tableProduct.pricePerUnit = product.price;
                                tableProduct.quantity = product.quantity;
                                tableProduct.created = order.timestamp;
                                tableProduct.orderID = key;
                                tableProduct.orderedBy = order.checkoutDetails.orderedBy;
                                tableProduct.orderedFor = order.checkoutDetails.orderedFor || '';

                                if(!product.deleted){

                                    products.push(tableProduct);

                                }

                            });

                            _.forEach(order.packages, (thePackage) => {

                                _.forEach(thePackage.customerPackageProducts, (product) => {

                                    let tableProduct = angular.copy(productRowInTable);

                                    tableProduct.productName = product.name;
                                    tableProduct.inPackage = true;

                                    if(thePackage.deleted){
                                        return;
                                        //tableProduct.deleted = true;
                                    }

                                    _.forEach(product.properties, (property, propKey) => {

                                        tableProduct[propKey] = property.name;

                                    });

                                    tableProduct.pricePerUnit = (thePackage.calculatedPackageCost/thePackage.customerPackageProducts.length);
                                    tableProduct.quantity = product.quantity;
                                    tableProduct.created = order.timestamp;
                                    tableProduct.orderID = key;
                                    tableProduct.orderedBy = order.checkoutDetails.orderedBy;
                                    tableProduct.orderedFor = order.checkoutDetails.orderedFor || '';

                                    if(!product.deleted){

                                        products.push(tableProduct);

                                    }

                                });

                            });

                        });

                        deferred.resolve(products);

                    });

                } else {

                    deferred.resolve(false);

                }

                return deferred.promise;
            }
        };

    });
})();
